<script>
import { computed, defineComponent, ref, onMounted, watch } from "vue"
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import htmlToPdf from "../utils/parsePdf"
import { getHtmlToMd } from "../utils/htmlToMd";
import { previeHTML2PDFFn } from "../utils/html2Pdf";
import { message, Modal, Button, Input, Spin } from "ant-design-vue"
import { $request } from '../utils/axios/index';
import config from '../config';
import exportToWord from '../utils/downloadDox';
import { dymicItemWaringFn, setfenyeWrapShowOrHide } from '@/utils/judFengyeLine'
export default defineComponent({
  name: "FinalInfo",
  components: {
    AModal: Modal,
    AButton: Button,
    AInput: Input,
    ASpin: Spin,
  },
  setup () {
    const store = useStore()
    const loading = ref(false)
    const title = ref('我的简历')
    let showModal = ref(false);

    const route = useRoute()
    // 监听路由
    watch(() => route.name, (name, preName) => {
      if (name !== 'Resume' && showModal.value) {
        handlePrePDFViewCancel();
      }
    }, { deep: true });

    const fianlInfoVisible = computed(() => {
      return store.state.fullFinalInfoVisible
    })

    const downloadPdfHandle = (downloadType) => {
      htmlToPdf.getPdf(title.value, downloadType, () => {
        downloadAfterFn();
      }, () => {
        downloadAfterFn(false)
      });
    };

    const handleOk = async (downloadType) => {
      store.commit('CHANGE_SLIDERVALUE', 1);
      if (downloadType == 'pdf') {
        try {
            let waringResult = await dymicItemWaringFn();
            console.log('isWaring:', waringResult);
            if (waringResult.hasItemWaring) {
              message.error('检测到你有内容处于分页线上, 请调整,否则内容将被截断');
              waringResult.itemWaringEle && waringResult.itemWaringEle.scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
              handleCancel();
              return;
            }
        } catch (error) {};
      }
      loading.value = true
      // 接口进行前置检测
      try {
       let result = await sendDownloadApiFn();
       if (!result || result.code != 0) {
          message.error(result.msg || `下载失败,请重试(${result.code || 5001})`);
          loading.value = false
          return;
       }
      } catch (error) {};
      setfenyeWrapShowOrHide('hide');
      setTimeout(() => {
        loading.value && (loading.value = false);
        setfenyeWrapShowOrHide('show');
      }, 1000 * 60 * 8);
      if (downloadType == 'md') {
        getHtmlToMd('tpl_box', title.value, () => {
          downloadAfterFn();
        }, (err) => {
          downloadAfterFn(false);
        })
      } else if (downloadType == 'image') {
        setTimeout(() => {
          downloadPdfHandle(downloadType);
        }, 16);
      } else if (downloadType == 'word') {
        setTimeout(() => {
          exportToWord('#tpl_box', {
            fileName: (title.value || '我的简历') + '.docx',
            callback: (status, err) => {
              if (status) {
                downloadAfterFn();
              } else {
                downloadAfterFn(false);
              }
            }
          });
        }, 16);
      } else {
        // renderPdfPreview(() => {
        //   downloadPdfHandle(downloadType);
        // });
        setTimeout(() => {
          downloadPdfHandle(downloadType);
        }, 16);
      };
    }

    let downloadAfterFn = (status = true) => {
        if (!status) {
          loading.value = false
          message.error('下载失败,请稍后重试');
          store.commit('CHANGE_FULL_INFO');
          // title.value = ''
          return;
        }
        setTimeout(async () => {
            loading.value = false
            message.success('下载成功')
            store.commit('CHANGE_FULL_INFO')
            // 接口进行成功计数
            try {
              setTimeout(() => {
                setfenyeWrapShowOrHide('show');
              }, 2000);
              let result = await sendDownloadApiFn('after');
              if (!result || result.code != 0) {
                  message.error(result.msg || `下载失败,请重试(${result.code || 5002})`);
              } else {
                store.state.downloadCount += 1;
              }
            } catch (error) {}
        }, 1000);
        // title.value = ''
    }

    const sendDownloadApiFn = (type = 'pre') => {
      return new Promise((resolve, reject) => {
          $request.resumeDownload({
            params: {},
            data: {
                  uid: store.state.userInfos.userid || '',
                  ColaKey: config.globalColaKey || '',
                  type: type || ''
                }
          }).then(resp => {
            resolve(resp);
          }).catch(err => {
            reject(err);
          })
      });
    }

    const showPrewPdfUrl = computed(() => {
      return store.state.pdfPreviewUrl + '#toolbar=0&view=FitH';
    })

    // 检测是否为Safari浏览器
    const isSafari = computed(() => {
      return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    })

    const handlePrePDFViewOk = () => {
      showModal.value = false;
      downloadPdfHandle('pdf');
    }

    const handlePrePDFViewCancel = () => {
      showModal.value = false;
      loading.value = false;
      setfenyeWrapShowOrHide('show');
      store.commit('CHANGE_FULL_INFO');
    }

    const renderPdfPreview = async (failCallback = () => {}) => {
      try {
        store.state.pdfPreviewUrl = await previeHTML2PDFFn('tpl_box');
        if (store.state.pdfPreviewUrl) {
          showModal.value = true;
        } else {
          showModal.value = false;
          message.warning('PDF预览失败');
          failCallback && failCallback();
        }
      } catch (error) {
        console.log('renderPdfPreview error:', error);
        failCallback && failCallback();
      }
    }

    onMounted(() => {
      window.$Bus.on('previeHTML2PDFFnEmit', async() => {
        renderPdfPreview
      });
    })

    const isVip = computed(() => {
      return store.state.vipData && store.state.vipData.status == 1;
    });


    const handleCancel = () => {
      store.commit('CHANGE_FULL_INFO')
      // title.value = ''
    }
    return {
      title,
      loading,
      handleOk,
      handleCancel,
      showModal,
      fianlInfoVisible,
      isVip,
      showPrewPdfUrl,
      handlePrePDFViewOk,
      handlePrePDFViewCancel,
      isSafari,
    }
  }
})
</script>
<template>
  <a-modal v-model:open="fianlInfoVisible" title="下载简历-自定义名称" @ok="handleOk" :closable="!loading" @cancel="handleCancel" :maskClosable="!loading">
    <!-- 全屏 Loading 遮罩 -->
    <div v-if="loading" class="modal-loading-overlay">
      <div class="loading-content">
        <a-spin size="large" />
        <div class="loading-text">文件生成中,可能需要几分钟请稍等</div>
      </div>
    </div>
    <template #footer>
      <div class="download-buttons-container">
        <div class="download-buttons-grid">
          <div class="download-button-item" @click="handleOk('pdf')" :class="{ 'disabled': loading }">
            <div class="button-icon pdf-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
              </svg>
            </div>
            <div class="button-content">
              <div class="button-title">导出PDF</div>
              <div class="button-desc">高清打印格式</div>
            </div>
          </div>
          
          <div class="download-button-item" @click="handleOk('word')" :class="{ 'disabled': loading }">
            <div class="button-icon word-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
              </svg>
            </div>
            <div class="button-content">
              <div class="button-title">导出Word</div>
              <div class="button-desc">可编辑文档</div>
            </div>
          </div>
          
          <div class="download-button-item" @click="handleOk('image')" :class="{ 'disabled': loading }">
            <div class="button-icon image-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M8.5,13.5L11,16.5L14.5,12L19,18H5M21,19V5C21,3.89 20.1,3 19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19Z"/>
              </svg>
            </div>
            <div class="button-content">
              <div class="button-title">导出图片</div>
              <div class="button-desc">PNG格式图片</div>
            </div>
          </div>
          
          <div class="download-button-item" @click="handleOk('md')" :class="{ 'disabled': loading }">
            <div class="button-icon md-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.56 18H3.44C2.65 18 2 17.35 2 16.56V7.44C2 6.65 2.65 6 3.44 6H20.56C21.35 6 22 6.65 22 7.44V16.56C22 17.35 21.35 18 20.56 18M3.44 6.89C3.18 6.89 2.89 7.18 2.89 7.44V16.56C2.89 16.82 3.18 17.11 3.44 17.11H20.56C20.82 17.11 21.11 16.82 21.11 16.56V7.44C21.11 7.18 20.82 6.89 20.56 6.89H3.44M4.89 9.64C4.89 9.11 5.36 8.64 5.89 8.64H18.11C18.64 8.64 19.11 9.11 19.11 9.64V14.36C19.11 14.89 18.64 15.36 18.11 15.36H5.89C5.36 15.36 4.89 14.89 4.89 14.36V9.64M6.34 10.55H17.66V13.45H6.34V10.55Z"/>
              </svg>
            </div>
            <div class="button-content">
              <div class="button-title">导出Markdown</div>
              <div class="button-desc">纯文本格式</div>
            </div>
          </div>
        </div>
        
        <div class="download-actions">
          <a-button @click="handleCancel" :disabled="loading">取消</a-button>
        </div>
      </div>
    </template>
    <a-input v-model:value="title" placeholder="请输入简历名称...." :disabled="loading"/>
    <p class="tips-info" v-if="!isVip"><b class="mr-2">温馨提示:</b>会员下载无水印,请前往[个人中心-充值中心]开通享高清下载.</p>
  </a-modal>
  <!-- PDF预览容器 -->
  <a-modal
          v-model:open="showModal"
    wrap-class-name="pdfview-full-modal"
    width="100%"
    title="PDF预览"
    cancelText="再去改改"
    okText="确认导出"
    @cancel="handlePrePDFViewCancel"
    @ok="handlePrePDFViewOk"
    >
    <div v-if="showPrewPdfUrl" class="pdf-preview">
      <iframe :src="showPrewPdfUrl" class="pdf-preview-iframe" title="PDF预览" v-if="isSafari"></iframe>
      <embed :src="showPrewPdfUrl" type="application/pdf" class="pdf-preview-iframe" v-else />
    </div>
  </a-modal>
</template>

<style lang="less">
.pdfview-full-modal {
  .ant-modal {
    max-width: 100%;
    top: 0;
    padding-bottom: 0;
    margin: 0;
  }
  .ant-modal-content {
    display: flex;
    flex-direction: column;
    height: calc(100vh);
  }
  .ant-modal-body {
    flex: 1;
  }
  .pdf-preview {
    width: 100%;
    height: 100%;
    padding: 10px;
    overflow: scroll;
    background: rgb(0, 0, 0, .8);
    .pdf-preview-iframe {
      width: 700px;
      height: 100%;
      margin: 0 auto;
    }
  }
}

.tips-info {
  @apply text-gray-400 mt-4;
  font-size: 12px;
}

/* 全屏 Loading 遮罩 */
.modal-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  border-radius: 8px;
}

.loading-content {
  text-align: center;
  padding: 40px 20px;
}

.loading-text {
  margin-top: 16px;
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

/* 下载按钮样式 */
.download-buttons-container {
  width: 100%;
}

.download-buttons-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 16px;
}

.download-button-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 16px;
  background: #f8f9fa;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 80px;
  
  &:hover {
    border-color: #1890ff;
    background: #f0f8ff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.15);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &.disabled {
    pointer-events: none;
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.button-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
  
  svg {
    width: 24px;
    height: 24px;
  }
  
  &.pdf-icon {
    background: linear-gradient(135deg, #ff4d4f, #ff7875);
    color: white;
  }
  
  &.word-icon {
    background: linear-gradient(135deg, #1890ff, #40a9ff);
    color: white;
  }
  
  &.image-icon {
    background: linear-gradient(135deg, #52c41a, #73d13d);
    color: white;
  }
  
  &.md-icon {
    background: linear-gradient(135deg, #722ed1, #9254de);
    color: white;
  }
}

.button-content {
  flex: 1;
  min-width: 0;
}

.button-title {
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 4px;
  line-height: 1.2;
}

.button-desc {
  font-size: 12px;
  color: #8c8c8c;
  line-height: 1.2;
}



.download-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .download-buttons-grid {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  
  .download-button-item {
    padding: 12px;
    min-height: 70px;
  }
  
  .button-icon {
    width: 32px;
    height: 32px;
    margin-right: 8px;
    
    svg {
      width: 20px;
      height: 20px;
    }
  }
  
  .button-title {
    font-size: 14px;
  }
  
  .button-desc {
    font-size: 11px;
  }
}
</style>
